import { ReactNode } from "react";
import { getDisplayInfo } from "utils/formatting";
import { percentageDifference } from "utils/mathFormulas/mathFormulas.helper";

export const prepareAnnualCarbonEmissionsOutcomes = (
    referencePlan: CarbonReductionPlan,
    comparedPlan: CarbonReductionPlan,
    referencePlanName: string,
    comparedPlanName: string
) => {
    // Lifetime Emissions
    const referencePlanLifetimeCarbonEmissions = referencePlan.planLifetimeCarbonEmissionsTotal;
    const comparedPlanLifetimeCarbonEmissions = comparedPlan.planLifetimeCarbonEmissionsTotal;
    const carbonEmissionsDifference = percentageDifference(
        comparedPlanLifetimeCarbonEmissions,
        referencePlanLifetimeCarbonEmissions
    );

    // Chart Data
    const chartAnnualCarbonEmissionsData = transformToEmissionsChartData(
        referencePlan.annualSummaries,
        comparedPlan.annualSummaries
    );

    // Tooltip
    const { unit: refEmissionsUnit, formatFunction: emissionFormatFunction } = getDisplayInfo(
        "annualCarbonEmissionsCurrent",
        referencePlanLifetimeCarbonEmissions
    );
    const { unit: compEmissionsUnit } = getDisplayInfo(
        "annualCarbonEmissionsCurrent",
        comparedPlanLifetimeCarbonEmissions
    );
    const formatedCarbonEmissionsRef = emissionFormatFunction(referencePlanLifetimeCarbonEmissions);
    const formatedCarbonEmissionsComp = emissionFormatFunction(comparedPlanLifetimeCarbonEmissions);

    const tooltipElement: ReactNode = (
        <>
            {comparedPlanName} emissions are {formatedCarbonEmissionsComp} {compEmissionsUnit}
            <br />
            <br />
            {referencePlanName} emissions are {formatedCarbonEmissionsRef} {refEmissionsUnit}
            <br />
            <br />
            There is a {carbonEmissionsDifference.toFixed(0)}% difference between the two plans
        </>
    );
    return {
        chartAnnualCarbonEmissionsData,
        referencePlanLifetimeCarbonEmissions,
        comparedPlanLifetimeCarbonEmissions,
        carbonEmissionsDifference,
        tooltipElement,
        formatedCarbonEmissionsRef,
    };
};

const transformToEmissionsChartData = (
    referenceAnnualSummary: AnnualSummary[],
    comparedAnnualSummary: AnnualSummary[]
) =>
    referenceAnnualSummary
        .map((referenceYear) => {
            const matchingComparedYear = comparedAnnualSummary.find(
                (comparedYear) => comparedYear.year === referenceYear.year
            );

            return {
                totalCarbonEmissionsReference: referenceYear.annualCarbonEmissions,
                totalCarbonEmissionsCompared: matchingComparedYear?.annualCarbonEmissions,
                year: referenceYear.year,
            };
        })
        .sort((a, b) => a.year - b.year);
